import React from "react"
import SubscribeForm from "components/SubscribeForm"

export default function NewsletterSubscription() {
  return (
    <div className="my-10 lg:my-20">
      <SubscribeForm segment="schools" />
    </div>
  )
}
